import { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

// Custom gold-ring cursor for precision-pointer (desktop/mouse) devices only.
// Expands over interactive elements (a, button, [data-cursor-hover]).
export const CustomCursor = () => {
  const [enabled, setEnabled] = useState(false);
  const [hovering, setHovering] = useState(false);
  const cursorX = useMotionValue(-100);
  const cursorY = useMotionValue(-100);
  const springX = useSpring(cursorX, { damping: 28, stiffness: 320, mass: 0.4 });
  const springY = useSpring(cursorY, { damping: 28, stiffness: 320, mass: 0.4 });

  useEffect(() => {
    const isFine = typeof window !== 'undefined' && window.matchMedia('(pointer: fine)').matches;
    setEnabled(isFine);
    if (!isFine) return;

    document.body.classList.add('lxra-cursor-none');

    const move = (e) => {
      cursorX.set(e.clientX);
      cursorY.set(e.clientY);
      const target = e.target;
      setHovering(!!(target && target.closest && target.closest('a, button, [data-cursor-hover]')));
    };
    window.addEventListener('mousemove', move);
    return () => {
      window.removeEventListener('mousemove', move);
      document.body.classList.remove('lxra-cursor-none');
    };
  }, [cursorX, cursorY]);

  if (!enabled) return null;

  return (
    <>
      <motion.div
        className="pointer-events-none fixed top-0 left-0 z-[100] rounded-full border border-[hsl(var(--lxra-gold))] mix-blend-difference"
        style={{ x: springX, y: springY, translateX: '-50%', translateY: '-50%' }}
        animate={{ width: hovering ? 46 : 18, height: hovering ? 46 : 18, opacity: hovering ? 0.9 : 0.7 }}
        transition={{ duration: 0.22, ease: [0.16, 1, 0.3, 1] }}
        data-testid="custom-cursor"
      />
      <motion.div
        className="pointer-events-none fixed top-0 left-0 z-[100] rounded-full bg-[hsl(var(--lxra-gold))]"
        style={{ x: cursorX, y: cursorY, translateX: '-50%', translateY: '-50%', width: 4, height: 4 }}
      />
    </>
  );
};
